import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import {isEditUserSettingsSitesGroupDrawer, isOpenUserSettingsSitesGroupDrawer, userSettingsSitesGroupFormData} from "../../@signals"
import UserSettingSitesGroupDrawerName from "./Name"
import UserSettingSitesGroupDrawerSites from "./Sites"
import UserSettingSitesGroupDrawerSubmit from "./SubmitButton"


export default function UserSettingSitesGroupDrawer() {
	const onClose = () => userSettingsSitesGroupFormData.value = { }

	return <AppFormDrawer
		icon="globe"
		title={isEditUserSettingsSitesGroupDrawer.value ? "Edit site group" : "New site group"}
		subtitle="A name and the sites it groups"
		isOpen={isOpenUserSettingsSitesGroupDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingSitesGroupDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="globe" title="Site group">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingSitesGroupDrawerName/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingSitesGroupDrawerSites/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
